import React, { useMemo, useState } from 'react'
import { gql, useQuery } from '@apollo/client'
import UserQuality from './UserQuality'
import WithMainLayout from '../../../hocs/withMainLayout'
import useDownloads from './useDownloads'
import { lastMonthRange, toGraphqlRange } from './dateUtils'

const GET_USER_QUALITY_STATISTICS = gql`
  query userQualityStatistics($dateRange: DateRangeInput!) {
    userQualityStatistics(dateRange: $dateRange) {
      quality {
        android
        ios
        total
      }
      lowQuality {
        android
        ios
        total
      }
      total
    }
  }
`

const GET_TRANSACTION_STATISTICS = gql`
  query transactionStatistics(
    $dateRange: DateRangeInput!
    $firstTimeBuyersOnly: Boolean
  ) {
    transactionStatistics(
      dateRange: $dateRange
      firstTimeBuyersOnly: $firstTimeBuyersOnly
    ) {
      subscriptionBreakdown {
        subscriptionType
        googleInApp
        googleCancel
        googleRefund
        appleInApp
        appleCancel
        appleRefund
        totalTransactions
      }
      totalCounts {
        subscriptionType
        googleInApp
        googleCancel
        googleRefund
        appleInApp
        appleCancel
        appleRefund
        totalTransactions
      }
      firstTimeBuyersCount
    }
  }
`

const UserQualityContainer = () => {
  // Applied range = inclusive ISO { from, to }; defaults to the whole previous
  // month. Presets update this immediately; the calendar only applies on the
  // "Применить" button (handled inside FilterBar).
  const [applied, setApplied] = useState(lastMonthRange())
  const [firstTimeBuyersOnly, setFirstTimeBuyersOnly] = useState(true)

  const dateRange = useMemo(() => toGraphqlRange(applied), [applied])

  const {
    data: userData,
    loading: userLoading,
    error: userError
  } = useQuery(GET_USER_QUALITY_STATISTICS, {
    variables: { dateRange },
    fetchPolicy: 'cache-and-network'
  })

  const {
    data: transactionData,
    loading: transactionLoading,
    error: transactionError
  } = useQuery(GET_TRANSACTION_STATISTICS, {
    variables: { dateRange, firstTimeBuyersOnly },
    fetchPolicy: 'cache-and-network'
  })

  const {
    data: downloads,
    loading: downloadsLoading,
    error: downloadsError
  } = useDownloads(applied)

  return (
    <UserQuality
      applied={applied}
      onApply={setApplied}
      userStatistics={userData && userData.userQualityStatistics}
      userLoading={userLoading}
      userError={userError}
      transactionStatistics={
        transactionData && transactionData.transactionStatistics
      }
      transactionLoading={transactionLoading}
      transactionError={transactionError}
      firstTimeBuyersOnly={firstTimeBuyersOnly}
      onFirstTimeBuyersToggle={setFirstTimeBuyersOnly}
      downloads={downloads}
      downloadsLoading={downloadsLoading}
      downloadsError={downloadsError}
    />
  )
}

export default WithMainLayout(UserQualityContainer)
